export function loadCartFromStorage() {
    try {
      const saved = localStorage.getItem("cart");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  }
  
  export function saveCartToStorage(cart) {
    try {
      // ?  saveToStorage("cart", cart);
      localStorage.setItem("cart", JSON.stringify(cart));
    } catch {
      // ignore
    }
  }

  export const saveToStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  };
  
  export const loadFromStorage = (key, defaultValue) => {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : defaultValue;
  };